<template>
    <div class="mb-8">
        <div :class="{ticked: isCompleted}" class="action bg-yellow border-l-8 border-yellow-dark w-full text-blue-darkest p-16">
            <div class="relative flex items-center justify-between mb-10">
                <span class="flex items-center">
                    <img :src="action.user.avatar || `/images/placeholders/avatar.png`" :alt="action.user.full_name" class="w-24 h-24 mr-8 rounded-full">
                    <p class="leading-tight"><strong>{{ action.user.full_name }}, </strong> {{ actionDate }}</p>
                </span>
                <span @click="toggleCompleted" class="group cursor-pointer">
                    <!--tick icon-->
                    <svg v-if="isCompleted" xmlns="http://www.w3.org/2000/svg" width="21.535" height="16.667" viewBox="0 0 21.535 16.667">
                        <path d="M7,9.475l6.65,5.542L25.167,3.5" transform="translate(-5.4 -1.732)" fill="none" stroke-width="5" class="stroke-blue-light group-hover:stroke-blue"/>
                    </svg>
                    <!--cross icon-->
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="17.895" height="17.172" viewBox="0 0 17.895 17.172">
                        <g transform="translate(-845.961 -6048.172)">
                            <path d="M11.65,17.017,25.167,3.5" transform="translate(836.5 6046.5)" fill="none" stroke-width="5" class="stroke-yellow-dark group-hover:stroke-yellow-darkest"/>
                            <path d="M25.65,17.017,11.167,3.5" transform="translate(836.5 6046.5)" fill="none" stroke-width="5" class="stroke-yellow-dark group-hover:stroke-yellow-darkest"/>
                        </g>
                    </svg>
                </span>
            </div>
            <p>
                <span v-html="text"></span>
                <span v-if="hasReadMore" @click="showMore = !showMore">
                    <span v-if="!showMore">
                        &hellip;
                        <strong>Read more</strong>
                    </span>
                    <strong v-else>Read less</strong>
                </span>
            </p>
        </div>
        <div v-if="isCompleted" class="w-full flex justify-end mb-16 mt-2">
            <span class="text-blue-lightest">Ticked by {{ completedUser.full_name }} on {{ completedDate }}</span>
        </div>
    </div>
</template>

<script>
    import { format, parseISO } from "date-fns"
    import { get } from 'vuex-pathify'
    import { orderBy } from "lodash";

    export default {
        props: {
            action: {
                type: Object,
                required: true
            }
        },

        data() {
            return {
                showMore: false,
                readMoreLimit: 20,
            }
        },

        computed: {
            user: get('auth/user'),

            actionDate() {
                return format(parseISO(this.action.created_at), 'dd-MM-yyyy')
            },

            activities() {
                return orderBy(this.action.activities, ['created_at'], ['desc'])
            },

            client() {
                return this.action.user.default_client
            },

            completedActivity() {
                if (this.isCompleted) {
                    return this.activities.find(activity => activity.properties.attributes.state === 'completed')
                }

                return null
            },

            completedDate() {
                return format(parseISO(this.completedActivity.created_at), 'dd-MM-yyyy')
            },

            completedUser() {
                if (this.completedActivity) {
                    return this.completedActivity.causer
                }

                return null
            },

            isCompleted() {
                return this.action.state === 'completed'
            },

            hasReadMore() {
                return this.textCount > this.readMoreLimit ? true : false
            },

            text() {
                if (this.showMore) {
                    return this.action.text
                }

                return this.splitText(this.action.text, this.readMoreLimit)
            },

            textCount() {
                return this.action.text.split(' ').length
            }
        },

        methods: {
            splitText(text, limit) {
                const textArray = text.split(' ')

                if (textArray.length > limit) {
                    return textArray.slice(0, limit).join(' ')
                }

                return text;
            },

            toggleCompleted() {
                if (this.isCompleted) {
                    this.$emit('active', this.action)
                } else {
                    this.$emit('complete', this.action)
                }
            }
        }
    }
</script>
